<div class="category-content">
	<div [ngClass]="{'loaded': !isLoaded}">
		<div #templateOutlet></div>
	</div>

	<clp-third-party-content 
		*ngIf="categoryData && isMainContentLoaded"
		[seoResponse]="categoryData"
	></clp-third-party-content>
</div>
